<div class="project-valuation-workplace-container">
  <div class="workplace-wrapper-outer">
    <div class="workplace-wrapper-inner">
      <div class="project-tabStrip-content">
        <projects-workspace [workplace]="this" [tabElement]="tabConfig[0]" id="tabProjectstd" [hidden]="selectedTab !== '#tabProjectstd'"></projects-workspace>
        <valuation-events-workspace [workplace]="this" [tabElement]="tabConfig[1]" id="tabValuationPortfolio" [hidden]="selectedTab !== '#tabValuationPortfolio'"></valuation-events-workspace>
        <reports-workspace [workplace]="this" [tabElement]="tabConfig[2]" id="tabReport" [hidden]="selectedTab !== '#tabReport'"></reports-workspace>
        <properties-workspace [workplace]="this" [tabElement]="tabConfig[3]" id="tabProperty" [hidden]="selectedTab !== '#tabProperty'"></properties-workspace>
        <tenants-workspace [workplace]="this" [tabElement]="tabConfig[4]" id="tabTenant" [hidden]="selectedTab !== '#tabTenant'"></tenants-workspace>
        <valuations-workspace [workplace]="this" [tabElement]="tabConfig[5]" id="tabValuation" [hidden]="selectedTab !== '#tabValuation'"></valuations-workspace>
      </div>
    </div>
  </div>
</div>
